import Button from '../button';
import ScrollSelect from '../scrollSelect';
import Time from './time';
import {Row, Col} from '../grid';
import {strPad, _$} from '../utils';
import {
    isEqual, isLT, isGT, getDateString,
    getTimeString, createDate, getYearBase,
    yearArray, monthArray
} from './utils';
import {Tabs, Tab} from '../tabs';
import Icon from '../icon';
import dayjs from 'dayjs';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    dayClassNames,
    multiple, onMouseEnterDay,
    type, hours, minutes, seconds, 
    disabledHours, disabledMinutes, disabledSeconds,
    _isShowYearPicker, _isShowMonthPicker, _isShowDatePicker,
    _isSelectTime, _now, _showDate,
    _focusDate, _id,
} = self.get();

const {value, values} = self._getRealValue();
const valueDate = value || _now;
const showDate = _showDate || valueDate;
const _showYear = Math.floor(showDate.get('year') / 10);

let yearMonthFormat = _$('yearMonthFormat');
if (yearMonthFormat === 'yearMonthFormat') {
    yearMonthFormat = 'YYYY MM';
}
const format = yearMonthFormat.split(' ');
const map = {
    'MM': (
        h('span', {
        'ev-click': function() {try {return (isYearOrMonth ? undefined : self.showMonthPicker )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (_$(`${showDate.get('month') + 1}月`) )} catch(e) {_e(e)}}.call($this), 'k-text')
    ),
    'YYYY': (
        h('span', {
        'ev-click': function() {try {return (self.showYearPicker )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (_$(`{n}年`, {n: showDate.get('year')}) )} catch(e) {_e(e)}}.call($this), 'k-text')
    )
};
const panel = format.map(item => map[item]);
const isYearOrMonth = self._isYearOrMonth();

    return h('div', {
        'tabindex': '0',
        'ev-keydown': function() {try {return (self._onKeydown )} catch(e) {_e(e)}}.call($this)
    }, [
        (_blocks['title'] = function(parent) {
            return null;
        }) && (__blocks['title'] = function(parent) {
            var args = arguments;
            return blocks['title'] ? blocks['title'].apply($this, [function() {
                return _blocks['title'].apply($this, args);
            }].concat(__slice.call(args, 1))) : _blocks['title'].apply($this, args);
        }) && __blocks['title'].apply($this, [__noop]),
        function() {try {return (type === 'datetime' )} catch(e) {_e(e)}}.call($this) ?
            h(Tabs, {
                'type': 'border-card',
                'value': function() {try {return (_isSelectTime ? "time" : "date" )} catch(e) {_e(e)}}.call($this),
                'children': [
                    h(Tab, {
                        'value': 'date',
                        'children': function() {try {return (value ? getDateString(valueDate.toDate()) : '0000-00-00' )} catch(e) {_e(e)}}.call($this),
                        '_context': $this
                    }),
                    h(Tab, {
                        'value': 'time',
                        'children': function() {try {return (value ? getTimeString(valueDate.toDate()) : '00:00:00' )} catch(e) {_e(e)}}.call($this),
                        '_context': $this
                    })
                ],
                '_context': $this,
                'ev-$change:value': function() {try {return (self._onChangeTab )} catch(e) {_e(e)}}.call($this)
            }) :
            undefined,
        function() {try {return (!_isSelectTime )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, [
                h('div', null, [
                    h('div', null, [
                        h(Button, {
                            'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                            'type': 'none',
                            'size': 'small',
                            'className': 'k-prev',
                            'tagName': 'div',
                            'tabindex': function() {try {return (null )} catch(e) {_e(e)}}.call($this),
                            'children': [
                                h(Icon, {
                                    'className': 'ion-ios-arrow-left',
                                    'size': 'small',
                                    '_context': $this
                                }),
                                h(Icon, {
                                    'className': 'ion-ios-arrow-left',
                                    'size': 'small',
                                    '_context': $this
                                })
                            ],
                            '_context': $this,
                            'ev-click': function() {try {return (self.prevYear )} catch(e) {_e(e)}}.call($this)
                        }),
                        function() {try {return (_isShowDatePicker )} catch(e) {_e(e)}}.call($this) ?
                            h(Button, {
                                'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                                'type': 'none',
                                'size': 'small',
                                'className': 'k-prev',
                                'tagName': 'div',
                                'tabindex': function() {try {return (null )} catch(e) {_e(e)}}.call($this),
                                'children': h(Icon, {
                                    'className': 'ion-ios-arrow-left',
                                    'size': 'small',
                                    '_context': $this
                                }),
                                '_context': $this,
                                'ev-click': function() {try {return (self.prevMonth )} catch(e) {_e(e)}}.call($this)
                            }) :
                            undefined
                    ], 'k-left-btns'),
                    h('div', null, [
                        h(Button, {
                            'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                            'type': 'none',
                            'size': 'small',
                            'className': 'k-next',
                            'tagName': 'div',
                            'tabindex': function() {try {return (null )} catch(e) {_e(e)}}.call($this),
                            'children': [
                                h(Icon, {
                                    'className': 'ion-ios-arrow-right',
                                    'size': 'small',
                                    '_context': $this
                                }),
                                h(Icon, {
                                    'className': 'ion-ios-arrow-right',
                                    'size': 'small',
                                    '_context': $this
                                })
                            ],
                            '_context': $this,
                            'ev-click': function() {try {return (self.nextYear )} catch(e) {_e(e)}}.call($this)
                        }),
                        function() {try {return (_isShowDatePicker )} catch(e) {_e(e)}}.call($this) ?
                            h(Button, {
                                'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                                'type': 'none',
                                'size': 'small',
                                'className': 'k-next',
                                'tagName': 'div',
                                'tabindex': function() {try {return (null )} catch(e) {_e(e)}}.call($this),
                                'children': h(Icon, {
                                    'className': 'ion-ios-arrow-right',
                                    'size': 'small',
                                    '_context': $this
                                }),
                                '_context': $this,
                                'ev-click': function() {try {return (self.nextMonth )} catch(e) {_e(e)}}.call($this)
                            }) :
                            undefined
                    ], 'k-right-btns'),
                    h('div', null, function() {try {return (_isShowYearPicker )} catch(e) {_e(e)}}.call($this) ?
                        h('span', null, function() {try {return (_$(`{n}年 - {m}年`, {n: _showYear * 10, m: _showYear * 10 + 9}) )} catch(e) {_e(e)}}.call($this), 'k-text') :
                        h('span', null, function() {try {return (panel )} catch(e) {_e(e)}}.call($this)), 'k-text-wrapper')
                ], 'k-month-year-btn c-clearfix'),
                function() {try {return (_isShowDatePicker )} catch(e) {_e(e)}}.call($this) ?
                    h('div', null, __m(function() {try {return ([_$('日'), _$('一'), _$('二'), _$('三'), _$('四'), _$('五'), _$('六')] )} catch(e) {_e(e)}}.call($this), function(value, key) {
                        return h('div', null, function() {try {return (value )} catch(e) {_e(e)}}.call($this), 'k-weekday');
                    }, $this), 'k-weekdays') :
                    undefined,
                function() {try {return (_isShowDatePicker )} catch(e) {_e(e)}}.call($this) ?
                    h('div', {
                        'ev-mouseleave': function() {try {return (self._onMouseLeaveDays )} catch(e) {_e(e)}}.call($this)
                    }, function() {try {return (function() {
                const ret = [];
                // dayjs is immutable, so we use js Date
                const start = showDate.toDate();
                const month = start.getMonth();
                start.setDate(1);
                start.setHours(0);
                start.setMinutes(0);
                start.setSeconds(0);
                const startWeekday = start.getDay(); 
                start.setDate(1 - startWeekday);

                for (let i = 0; i < 42; i++) {
                    const dayjsDate = dayjs(start);
                    const _date = start.getDate();
                    const _month = start.getMonth();
                    const disabled = self._isDisabledDate(dayjsDate); 
                    const isOut = _month !== month;
                    const classNames = dayClassNames ? 
                        dayClassNames.call(self, dayjsDate, isOut) : 
                        null;
                    ret.push(
                        h('div', {
                        'ev-click': function() {try {return (!disabled && self.select.bind(self, dayjsDate) )} catch(e) {_e(e)}}.call($this),
                        'ev-mouseenter': function() {try {return (self._onMouseEnter.bind(self, dayjsDate, isOut) )} catch(e) {_e(e)}}.call($this)
                    }, function() {try {return (_date )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                                "k-day": true,
                                "k-out": isOut,
                                "k-active": !isOut && values.find(value => {
                                    return isEqual(value, dayjsDate, 'date');
                                }),
                                "k-today": isEqual(_now, dayjsDate, 'date'),
                                "k-disabled": disabled, 
                                "k-hover": isEqual(_focusDate, dayjsDate, 'date'),
                                ...classNames
                            } )} catch(e) {_e(e)}}.call($this)))
                    );
                    start.setDate(start.getDate() + 1);
                }
                const result = [];
                for (let i = 0; i < 6; i++) {
                    result.push(h('div', null, function() {try {return (ret.slice(7 * i, 7 * (i + 1)) )} catch(e) {_e(e)}}.call($this)))
                }

                return result;
            }() )} catch(e) {_e(e)}}.call($this), 'k-calendar') :
                    undefined,
                h('div', null, [
                    function() {try {return (_isShowMonthPicker )} catch(e) {_e(e)}}.call($this) ?
                        h('div', null, function() {try {return (function() {
                    const ret = [];
                    const start = showDate.toDate();
                    for (let i = 0; i < 12; i++) {
                        const _month = i;
                        const disabled = self._isDisabledMonth(_month);
                        start.setMonth(_month);
                        const dayjsDate = dayjs(start);
                        ret.push(
                            h('div', {
                            'ev-click': function() {try {return (!disabled && self.onChangeMonth.bind(self, _month) )} catch(e) {_e(e)}}.call($this),
                            'ev-mouseenter': function() {try {return (self._onMouseEnter.bind(self, dayjsDate, false) )} catch(e) {_e(e)}}.call($this)
                        }, function() {try {return (_$(`${_month + 1}月`) )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                                    "k-month-year": true,
                                    "k-disabled": disabled,
                                    "k-active": isEqual(value, dayjsDate, 'month'),
                                    "k-today": isEqual(_now, dayjsDate, 'month'),
                                    "k-hover": isEqual(_focusDate, dayjsDate, 'month')
                                } )} catch(e) {_e(e)}}.call($this)))
                        )
                    }
                    const result = [];
                    for (let i = 0; i < 3; i++) {
                        result.push(h('div', null, function() {try {return (ret.slice(4 * i, 4 * (i + 1)) )} catch(e) {_e(e)}}.call($this), 'k-month-year-row'))
                    }
                    return  result;
                }() )} catch(e) {_e(e)}}.call($this)) :
                        undefined,
                    function() {try {return (_isShowYearPicker )} catch(e) {_e(e)}}.call($this) ?
                        h('div', null, function() {try {return (function() {
                    const ret = [];
                    const start = showDate.toDate();
                    start.setFullYear(_showYear * 10 - 1);
                    for (let i = 0; i < 12; i++) {
                        const dayjsDate = dayjs(start);
                        const _year = start.getFullYear();
                        const disabled = self._isDisabledYear(_year);
                        const isOut = Math.floor(_year / 10) !== _showYear;
                        ret.push(
                            h('div', {
                            'ev-click': function() {try {return (!disabled && self.onChangeYear.bind(self, _year) )} catch(e) {_e(e)}}.call($this),
                            'ev-mouseenter': function() {try {return (self._onMouseEnter.bind(self, dayjsDate, isOut) )} catch(e) {_e(e)}}.call($this)
                        }, function() {try {return (_year )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                                    "k-month-year": true,
                                    "k-disabled": disabled,
                                    "k-out": isOut,
                                    "k-active": !isOut && isEqual(value, dayjsDate, 'year'),
                                    "k-today": isEqual(_now, dayjsDate, 'year'),
                                    "k-hover": isEqual(_focusDate, dayjsDate, 'year')
                                } )} catch(e) {_e(e)}}.call($this)))
                        );
                        start.setFullYear(start.getFullYear() + 1);
                    }
                    const result = [];
                    for (let i = 0; i < 3; i++) {
                        result.push(h('div', null, function() {try {return (ret.slice(4 * i, 4 * (i + 1)) )} catch(e) {_e(e)}}.call($this), 'k-month-year-row'))
                    }
                    return result;
                }() )} catch(e) {_e(e)}}.call($this)) :
                        undefined
                ], 'k-calendar')
            ], 'k-date-picker') :
            h('div', {
                'ev-wheel': function() {try {return (self._onWheel )} catch(e) {_e(e)}}.call($this)
            }, (_blocks['time-body'] = function(parent) {
                return h(Time, {
                    'data': function() {try {return ([
                    hours.map(v => strPad(v, 2)),
                    minutes.map(v => strPad(v, 2)),
                    seconds.map(v => strPad(v, 2)),
                ] )} catch(e) {_e(e)}}.call($this),
                    'value': function() {try {return (value ||
                    // if exists _id, it indicate that this is a range time selection of Timepicker
                    // we don't let Time to trigger $change:value in initial
                    // otherwise the start time will be disabled due to the end time is 00:00:00
                    // #119
                    self.get('_id') ? 
                        [
                            strPad(valueDate.hour(), 2),
                            strPad(valueDate.minute(), 2),
                            strPad(valueDate.second(), 2),
                        ] : 
                        ['', '', '']
                )} catch(e) {_e(e)}}.call($this),
                    'disabledItems': function() {try {return ([disabledHours, disabledMinutes, disabledSeconds] )} catch(e) {_e(e)}}.call($this),
                    'min': function() {try {return (self._getMinDate() )} catch(e) {_e(e)}}.call($this),
                    'max': function() {try {return (self._getMaxDate() )} catch(e) {_e(e)}}.call($this),
                    'date': function() {try {return (scope.date || valueDate )} catch(e) {_e(e)}}.call($this),
                    'isDisabledTime': function() {try {return (self._isDisabledTime )} catch(e) {_e(e)}}.call($this),
                    '_context': $this,
                    'ev-change': function() {try {return (self.onChangeTime )} catch(e) {_e(e)}}.call($this)
                });
            }) && (__blocks['time-body'] = function(parent) {
                var args = arguments;
                return blocks['time-body'] ? blocks['time-body'].apply($this, [function() {
                    return _blocks['time-body'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['time-body'].apply($this, args);
            }) && __blocks['time-body'].apply($this, [__noop]), 'k-time-picker', 'time')
    ], _className(function() {try {return ({
        "k-calendar-wrapper": true,
        "k-datetime": type === 'datetime',
    } )} catch(e) {_e(e)}}.call($this)))
}